<template>
  <div
    role="alert"
    data-form-problem-banner
    :class="rootClass"
  >
    <p
      v-if="problem.fieldCount > 0"
      :class="headlineClass"
    >
      {{ $t('common.formProblem.fixFields', { count: problem.fieldCount }) }}
    </p>

    <p
      v-else-if="problem.kind === 'network'"
      :class="headlineClass"
    >
      {{ $t('common.formProblem.network') }}
    </p>

    <ul v-if="problem.messages.length > 0">
      <li
        v-for="(message, index) in problem.messages"
        :key="index"
        :class="messageClass"
      >
        {{ message }}
      </li>
    </ul>

    <div
      v-if="problem.requestId !== null"
      :class="footerClass"
    >
      <Tooltip
        :content="$t('common.formProblem.incidentNumberHelp')"
        :label="$t('common.formProblem.incidentNumberHelp')"
      >
        <template #trigger>{{ $t('common.formProblem.incidentNumber') }}</template>

        <template #icon>
          <InformationCircleIcon
            class="size-3.5"
            aria-hidden="true"
          />
        </template>
      </Tooltip>

      <span class="font-mono">{{ problem.requestId }}</span>

      <CopyToClipboard
        :text="problem.requestId"
        :label="$t('common.formProblem.copyIncidentNumber')"
        :copied-message="$t('common.formProblem.copySuccess')"
        :failed-message="$t('common.formProblem.copyFailed')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { InformationCircleIcon } from '@heroicons/vue/20/solid'
import { computed } from 'vue'

import CopyToClipboard from '~/design-system/atoms/CopyToClipboard/CopyToClipboard.atom.vue'
import Tooltip from '~/design-system/atoms/Tooltip/Tooltip.atom.vue'
import type { FormProblemState } from '~/services/forms/FormProblemState'

defineProps<{
  /** The resolved form validation problem to present. */
  problem: FormProblemState
}>()

// Bound so tailwindcss/classnames-order and vue/static-class-names-order, which disagree on this order, do not both apply.
const rootClass = computed(() => 'bg-danger-50 dark:bg-danger-900/20 mb-4 p-4 rounded-md')
const headlineClass = computed(() => 'dark:text-danger-200 font-medium text-danger-800 text-sm')
const messageClass = computed(() => 'dark:text-danger-200 text-danger-800 text-sm')
const footerClass = computed(
  () => 'dark:text-danger-300/70 flex gap-1.5 items-center mt-1 text-danger-800/70 text-xs'
)
</script>
